export default {
  title: 'User Profil',
  close: 'Schließen',
  rules: {
    required: 'Feld darf nicht leer sein',
    min: 'Feld braucht mindestens',
    max: 'Feld darf nicht länger sein als',
    characters: 'Zeichen',
    fieldIncorrect: 'Wert ist falsch',
    loginIncorrect: 'E-Mail ist falsch',
    passwordIncorrect: 'Passwort ist falsch',
    passwordMustDiffer: 'Das neue Passwort muss sich vom alten unterscheiden',
    passwordMustBeSame: 'Passwörter stimmen nicht überein',
  },
  user: {
    login: 'E-Mail Adresse',
    name: 'Benutzername',
    restore: 'Wiederherstellen',
    save: 'Speichern',
    updated: 'Benutzerdaten wurden erneuert',
  },
  password: {
    old: 'Altes Passwort',
    new: 'Neues Passwort',
    repeat: 'Passwort wiederholen',
    updated: 'Passwort wurde geändert',
    updateError: 'Passwort konnte nicht geändert werden',
    clear: 'Leeren',
    change: 'Passwort ändern',
  },
}
